import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Checkbox } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { ReservationGroupDispatchProps, ReservationGroupStateProps } from '../types';
import { areAllReservationByIdsChecked, isAnyReservationByIdsChecked } from '../../../selectors';
import { setReservationsChecked } from '../../../actions';

interface OwnProps {
    scope: string;
    reservationIds: string[];
}
type Props = ReservationGroupStateProps & ReservationGroupDispatchProps & OwnProps;

const CheckAllCheckbox = ({ reservationIds, scope, isAnyChecked, areAllChecked, toggleChecked }: Props) => {
    const handleChange = () => toggleChecked({ reservationIds, scope, isChecked: !areAllChecked });
    return <Checkbox checked={isAnyChecked} indeterminate={isAnyChecked && !areAllChecked} onChange={handleChange} />;
};

export default connect<ReservationGroupStateProps, ReservationGroupDispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        areAllChecked: areAllReservationByIdsChecked,
        isAnyChecked: isAnyReservationByIdsChecked,
    }),
    { toggleChecked: setReservationsChecked }
)(CheckAllCheckbox);
